var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{staticClass:"esep-card-header"},[_c('h4',{staticClass:"float-left text-light font-weight-bold"},[_c('b-icon',{attrs:{"icon":this.iconName}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }